module.exports = __webpack_public_path__ + "assets/hourglass.4a379f403afb3c21888731bc1af2c50a.svg";